import { render, staticRenderFns } from "./StudyModality.vue?vue&type=template&id=9b856fea&"
import script from "./StudyModality.vue?vue&type=script&lang=js&"
export * from "./StudyModality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports